import { Injectable } from '@angular/core';

@Injectable()
export class SecondsToTimeService {
    constructor() {}

    getTime(totalSeconds: number) {
        var seconds = totalSeconds % 60;
        var minutes = ((totalSeconds - seconds) / 60) % 60;
        var hours = (totalSeconds - minutes * 60 - seconds) / 60 / 60;
        return hours + ':' + minutes.toString().paddingLeft('00') + ':' + seconds.toString().paddingLeft('00');
    }
}
